import PropTypes from 'prop-types';

export const countryType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  iso_3166_2: PropTypes.string,
});

export const RECOGNITION_NOTICE_LEVEL_NONE = 'none';
export const RECOGNITION_NOTICE_LEVEL_WARNING = 'warning';
export const RECOGNITION_NOTICE_LEVEL_LIMIT_REACHED = 'limit_reached';

/**
 * Monthly company-recognition limit state of the current user's client,
 * as returned by `GET /current_user` (`recognition_notice`) and
 * `GET /current_user/recognition_notice`. The backend decides the level and
 * localises the message; the frontend only renders them.
 *
 * @typedef {Object} RecognitionNotice
 * @property {'none'|'warning'|'limit_reached'} level
 * @property {number} threshold_percent
 * @property {string} period_start YYYY-MM-DD
 * @property {string} period_end YYYY-MM-DD, inclusive
 * @property {number} recognitions_count
 * @property {?number} monthly_limit null when the client has no package
 * @property {?number} remaining never below 0
 * @property {?number} used_percent rounded down, may exceed 100
 * @property {?string} message localised, null when level is 'none'
 */
export const recognitionNoticeType = PropTypes.shape({
  level: PropTypes.oneOf([
    RECOGNITION_NOTICE_LEVEL_NONE,
    RECOGNITION_NOTICE_LEVEL_WARNING,
    RECOGNITION_NOTICE_LEVEL_LIMIT_REACHED,
  ]).isRequired,
  threshold_percent: PropTypes.number,
  period_start: PropTypes.string,
  period_end: PropTypes.string,
  recognitions_count: PropTypes.number,
  monthly_limit: PropTypes.number,
  remaining: PropTypes.number,
  used_percent: PropTypes.number,
  message: PropTypes.string,
});

/** @type {RecognitionNotice} */
export const defaultRecognitionNotice = {
  level: RECOGNITION_NOTICE_LEVEL_NONE,
  threshold_percent: 90,
  period_start: null,
  period_end: null,
  recognitions_count: 0,
  monthly_limit: null,
  remaining: null,
  used_percent: null,
  message: null,
};



// WEBPACK FOOTER //
// ./src/types/index.js